module.exports = __webpack_public_path__ + "img/caregiver-avatar-default.39203b36.svg";